
import { Project, Location } from '../types';
import { apiService } from '../services/api';

export const getProjects = async (): Promise<Project[]> => {
  try {
    return await apiService.getProjects();
  } catch (error) {
    console.error('Error fetching projects:', error);
    return [];
  }
};

export const getLocations = async (): Promise<Location[]> => {
  try {
    return await apiService.getLocations();
  } catch (error) {
    console.error('Error fetching locations:', error);
    return [];
  }
};

export const addProject = async (name: string): Promise<Project | null> => {
  try {
    console.log('dataManager: Creating project with name:', name);
    const result = await apiService.createProject({ name: name.trim() });
    console.log('dataManager: Project created successfully:', result);
    return result;
  } catch (error: unknown) {
    console.error('dataManager: Error creating project:', error);
    const err = error as { details?: { error?: string }; message?: string };
    console.error('dataManager: Error details:', err.details);
    console.error('dataManager: Error message:', err.message);
    alert(`Eroare la adăugarea proiectului: ${err.details?.error || err.message || 'Eroare necunoscută'}`);
    return null;
  }
};

export const addLocation = async (name: string): Promise<Location | null> => {
  try {
    return await apiService.createLocation({ name: name.trim() });
  } catch (error) {
    console.error('Error creating location:', error);
    return null;
  }
};

export const deleteProject = async (id: number): Promise<boolean> => {
  try {
    await apiService.deleteProject(id);
    return true;
  } catch (error: unknown) {
    console.error('Error deleting project:', error);
    const err = error as { details?: { error?: string }; message?: string };
    const errorMessage = err.details?.error || err.message || 'Eroare necunoscută';
    
    if (err.message?.includes('404') || errorMessage.includes('not found')) {
      alert('Proiectul nu mai există. Se va reîncărca lista.');
      // Reload the list to get fresh data
      window.location.reload();
    } else if (errorMessage.includes('existing work entries')) {
      alert('Nu se poate șterge proiectul deoarece există înregistrări de timp asociate. Ștergeți mai întâi toate înregistrările de timp pentru acest proiect.');
    } else if (errorMessage.includes('material allocations')) {
      alert('Nu se poate șterge proiectul deoarece există alocări de materiale asociate.');
    } else {
      alert(`Eroare la ștergerea proiectului: ${errorMessage}`);
    }
    return false;
  }
};

export const deleteLocation = async (id: number): Promise<boolean> => {
  try {
    await apiService.deleteLocation(id);
    return true;
  } catch (error: unknown) {
    console.error('Error deleting location:', error);
    const err = error as { details?: { error?: string }; message?: string };
    const errorMessage = err.details?.error || err.message || 'Eroare necunoscută';
    
    if (err.message?.includes('404') || errorMessage.includes('not found')) {
      alert('Locația nu mai există. Se va reîncărca lista.');
      // Reload the list to get fresh data
      window.location.reload();
    } else if (errorMessage.includes('existing work entries')) {
      alert('Nu se poate șterge locația deoarece există înregistrări de timp asociate. Ștergeți mai întâi toate înregistrările de timp pentru această locație.');
    } else {
      alert(`Eroare la ștergerea locației: ${errorMessage}`);
    }
    return false;
  }
};

export const updateProject = async (id: number, name: string): Promise<boolean> => {
  try {
    await apiService.updateProject(id, { name: name.trim() });
    return true;
  } catch (error) {
    console.error('Error updating project:', error);
    return false;
  }
};

export const updateLocation = async (id: number, name: string): Promise<boolean> => {
  try {
    await apiService.updateLocation(id, { name: name.trim() });
    return true;
  } catch (error) {
    console.error('Error updating location:', error);
    return false;
  }
};
